// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";

// components

// actions
import { init, fetchPageData } from "./actions";

// selectors
import { getIsRequesting } from "Selectors/app";
import { getData, getCSVData } from "./selectors";

// css
import css from "./Page";

class RecentlyDeactivatedPage extends React.PureComponent {
	static propTypes = {
		isRequesting: PropTypes.bool.isRequired,
		init: PropTypes.func.isRequired,
		fetchPageData: PropTypes.func.isRequired,
		downloadCSV: PropTypes.func.isRequired,
		environment: PropTypes.string.isRequired,
		csvData: PropTypes.string.isRequired,
		data: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.init();
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.environment !== this.props.environment) {
			this.props.fetchPageData();
		}
	};

	downloadCSV = () => {
		this.props.downloadCSV();
	};

	render = () => {
		const { data, csvData, isRequesting } = this.props;

		return (
			<div className={css.Main}>
				<div className={css.container}>
					<div className={css.buttonContainer}>
						{!isRequesting ? (
							<CSVLink
								className={css.downloadButton}
								filename="recently_deactivated_users.csv"
								data={csvData}
							>
								Download CSV ( Found {data.size} Users)
							</CSVLink>
						) : null}
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	data: getData(state),
	csvData: getCSVData(state),
	isRequesting: getIsRequesting(state, "USERS:DEACTIVATED"),
});

const mapDispatchToProps = (dispatch) => ({
	downloadCSV: () => dispatch(downloadCSV()),
	fetchPageData: () => dispatch(fetchPageData()),
	init: (graphWidth) => dispatch(init(graphWidth)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentlyDeactivatedPage);
